export { default } from './es/icons/SearchOutlined';